import React from 'react'

export default function Title(props) {
  const { title, className="", as='h2', size='2xl', theme='zink' } = props

  const themeClass = {
    zink: 'text-zink-200',
    white: 'text-white',
    black: 'text-black',
    primary: 'text-primary',
  }
  const Element = as

  return (
    <Element className={`text-${size} font-bold ${themeClass[theme]} ${className}`}>{title}</Element>
  )
}
